<template>
    <v-container fluid grid-list-md class="horizontal-padding-content">
        <v-row>
            <v-col cols="12">
                <v-card class="rounded-card" height="100%">
                    <v-card-title class="primary--text pt-1 pb-0">
                        <v-row :class="{ 'pb-0 mb-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }">
                            <v-col order-lg="2" cols="12" lg="6" class="text-uppercase primary--text text-center font-weight-black">
                                Detalle de intereses facturados
                            </v-col>
                            <v-col  order-lg="3">
                              <ExportTable
                                :fileName="fileName"
                                :mapFunction="mapFunction"
                                :dataToExport="records"
                                :headers="excelHeaders"
                              />
                            </v-col>
                            <v-col order-lg="1" cols="12" lg="3">
                                <v-menu
                                  :close-on-content-click="true"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      class="capitalize-input"
                                      outlined
                                      dense
                                      label="Mes"
                                      append-icon="mdi-menu-down"
                                      v-on="on"
                                      v-model="dateFormatted"
                                    />
                                  </template>
                                  <v-date-picker
                                    type="month"
                                    :allowed-dates="disableFutureMonths"
                                    v-model="month"
                                    locale="es"
                                    @change="loadRecords()"
                                    />
                              </v-menu>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" order-lg="12" cols="12" lg="12" class="text-right">
                              <!-- SIEMPRE NO, PERO SE DEJA POR SI LO PIDEN, SOLO FALTARIA TOTALIZAR -->
                              <!-- <v-row justify="end">
                                <v-col cols="12" sm="4" md="4">
                                  <v-card class="pr-5 pl-5" elevation="4">
                                    <v-card-title class="text-subtitle-2 font-weight-bold center-title">
                                      RESUMEN
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-row>
                                      <v-col cols="6" class="text-caption text-right">
                                        <span class="ml-1">Total de intereses en USD:</span>
                                      </v-col>
                                      <v-col cols="6" class="text-right text-caption font-weight-bold">
                                        $0.00
                                      </v-col>
                                    </v-row>

                                    <v-row>
                                      <v-col cols="6" class="text-caption text-right">
                                        <v-icon color="blue" small>mdi-currency-mxn</v-icon>
                                        <span class="ml-1">Total de intereses en MXN:</span>
                                      </v-col>
                                      <v-col cols="6" class="text-right text-caption font-weight-bold">
                                        $0.00
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                              </v-row> -->
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text
                      class="primary--text pt-1 pb-0"
                      :class="{ 'pt-0 mt-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
                    >
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                  :headers="headers"
                                  :items="records"
                                  :loading="loading"
                                  loading-text="Cargando datos"
                                  no-data-text="No hay datos para mostrar"
                                  class="elevation-2"
                                  :class="{ 'mt-0 pt-0': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs }"
                                  :footer-props="{
                                    'items-per-page-all-text': 'Todos',
                                    'items-per-page-options': [-1],
                                    'disable-pagination': true
                                  }">
                                    <template v-slot:[`item.interest`]="{ item }">
                                        {{ item.interest | currency }}
                                    </template>
                                    <template v-slot:[`item.iva`]="{ item }">
                                        {{ item.iva | currency }}
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import CreditsManagerService from '@/services/CreditsManagerService'
import moment from 'moment'
import ExportTable from '@/components/ExportTable'

export default {
  name: 'InterestHistory',
  components: {
    ExportTable
  },
  data () {
    return {
      loading: false,
      searchRecord: {
        startDate: moment(new Date()).subtract(1, 'months').startOf('month').locale('es').format('YYYY-MM-DD'),
        endDate: moment(new Date()).subtract(1, 'months').endOf('month').locale('es').format('YYYY-MM-DD')
      },
      records: [],
      month: this.getPreviousMonth(),
      dateFormatted: moment().subtract(1, 'months').locale('es').format('MMMM YYYY'),
      headers: [
        { text: 'Periodo', value: 'month', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Folio', value: 'folioInvoice', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Interés', value: 'interest', align: 'end', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'I.V.A.', value: 'iva', align: 'end', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Moneda', value: 'currency', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Producto', value: 'productName', align: 'center', class: 'primary--text font-weight-black text-uppercase' }
      ],
      excelHeaders: {
        month: 'Periodo Facturado',
        folioInvoice: 'Folio',
        interest: 'Interes',
        iva: 'I.V.A.',
        currency: 'Moneda',
        productName: 'Producto'
      }
    }
  },

  beforeCreate () {
    if (!this.$store.getters.isLoggedIn) {
      const routeData = this.$router.resolve({ name: 'login' })
      window.open(routeData.href, '_self')
    }
  },

  async mounted () {
    if (this.$store.getters.isLoggedIn) {
      await this.$store.dispatch('setProducts')
      this.loadRecords()
    }
  },
  watch: {
    month (val) {
      this.dateFormatted = moment(this.month).locale('es').format('MMMM YYYY')
      this.searchRecord.startDate = moment(this.month).startOf('month').locale('es').format('YYYY-MM-DD')
      this.searchRecord.endDate = moment(this.month).endOf('month').locale('es').format('YYYY-MM-DD')
    }
  },
  methods: {
    mapFunction (item) {
      return Object.assign({
        month: item.month,
        folioInvoice: item.folioInvoice,
        interest: item.interest,
        iva: item.iva,
        currency: item.currency,
        productName: item.productName
      })
    },

    getPreviousMonth () {
      return moment().subtract(1, 'months').locale('es').format('YYYY-MM')
    },

    disableFutureMonths (date) {
      return date < moment().format('YYYY-MM')
    },

    async loadRecords () {
      const loader = this.$loading.show()
      this.loading = true
      this.searchRecord.products = [this.$store.getters.products.BI.productId, this.$store.getters.products.FB.productId]
      this.searchRecord.clientIds = [this.$store.getters.user.client.clientId]

      try {
        const { data } = await CreditsManagerService.getInterest(this.searchRecord)
        this.records = data.credits
        this.records = this.records.map(item => {
          return {
            folioInvoice: item.folioInvoice,
            interest: item.interest,
            month: moment(this.month).locale('es').format('MMMM YYYY').toUpperCase(),
            iva: item.iva,
            currency: item.currency,
            productName: item.productName
          }
        }).filter(_ => _.interest > 0)
        loader.hide()
        this.loading = false
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    }
  },

  computed: {
    fileName () { return `Intereses ${this.dateFormatted}` }
  }
}
</script>

<style>
    .capitalize-input input {
        text-transform: uppercase !important;
        color: #0420BF!important;
        font-weight: 900 !important;
        font-size: 20px !important;
    }
    /* .center-title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      text-align: center;
    } */
</style>
